/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ActiveInputs */

const en_share_active = /** @type {(inputs: Share_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active links`)
};

const de_share_active = /** @type {(inputs: Share_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Links`)
};

/**
* | output |
* | --- |
* | "Active links" |
*
* @param {Share_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_active = /** @type {((inputs?: Share_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_active(inputs)
	return en_share_active(inputs)
});